import { useModal } from '@ebay/nice-modal-react';
import { useEffect, useMemo } from 'react';

import { implog } from '@/api/implog';
import imgClose from '@/assets/download/close.webp';
import imgHand from '@/assets/download/hand.webp';
import IosDownloadChrome from '@/assets/download/ios_chrome_tip.webp';
import IosDownloadSafari from '@/assets/download/ios_safari_tip.webp';
import imgFrame from '@/assets/modal/frame.webp';
import BlurryLoadingImage from '@/components/progressive-img';
import { iosForceCollectChannels } from '@/constant/config';
import useDevice from '@/hooks/useDevice';
import globalStore from '@/stores/store';
import { getBrowser, getDevice, inPwaEnv, isInChromeBrowser } from '@/utils/utils';

import styles from './styles.module.less';

const IosPwaModal = () => {
  const isChrome = isInChromeBrowser();
  const modal = useModal();
  const { isIos, device } = useDevice();
  const browser = getBrowser();
  const channel = getAPKCHSource().toLocaleUpperCase().replace('CH_', '');

  const isIosForceCollect = useMemo(() => {
    return globalStore?.initialState.viplevel > 0 && isIos && iosForceCollectChannels.includes(channel) && !inPwaEnv();
  }, [globalStore?.initialState.viplevel, isIos]);

  const close = () => {
    modal.hide();
  };

  useEffect(() => {
    isIosForceCollect
      ? implog('ios_pwa_vip_guide_show', { device, browser })
      : implog('ios_pwa_guide_show', { device, browser });
  }, []);

  return (
    <div className={styles.body}>
      {!isChrome && (
        <div className={styles.header}>
          <img src={imgFrame} alt="" />
          <div>Open the app on your home screen for a full gaming and withdrawal experience.</div>
        </div>
      )}
      <div className={styles.container}>
        {isChrome ? (
          <BlurryLoadingImage loading="lazy" src={IosDownloadChrome} />
        ) : (
          <BlurryLoadingImage loading="lazy" src={IosDownloadSafari} />
        )}

        <img src={imgHand} className={isChrome ? styles.hand_top : styles.hand} />

        <img src={imgClose} alt="" className={isChrome ? styles.close_up : styles.close} onClick={close} />
      </div>

      {isChrome && (
        <div className={styles.header} style={{ marginTop: '0.5rem' }}>
          <img src={imgFrame} alt="" />
          <div>Open the app on your home screen for a full gaming and withdrawal experience.</div>
        </div>
      )}
    </div>
  );
};

export default IosPwaModal;
